import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetCreatedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetCreatedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetCreatedEvent.type = 'com.treeplotter.api.asset.created.v1';
EventRegistry.register(AssetCreatedEvent.type, AssetCreatedEvent);
//# sourceMappingURL=asset-created.event.js.map